/**
 * Ícones de interface unificados com Lucide (lucide-react / lucide.dev).
 * Mesma linguagem visual: traço 2, viewBox 24×24, currentColor — alinhado às marcas em simpleBrandIcons (Simple Icons).
 *
 * @see https://lucide.dev — ISC License
 */
import { __iconNode as check } from 'lucide-react/dist/esm/icons/check.js';
import { __iconNode as arrowUp } from 'lucide-react/dist/esm/icons/arrow-up.js';
import { __iconNode as arrowDown } from 'lucide-react/dist/esm/icons/arrow-down.js';
import { __iconNode as externalLink } from 'lucide-react/dist/esm/icons/external-link.js';
import { __iconNode as link } from 'lucide-react/dist/esm/icons/link.js';
import { __iconNode as gripVertical } from 'lucide-react/dist/esm/icons/grip-vertical.js';
import { __iconNode as image } from 'lucide-react/dist/esm/icons/image.js';
import { __iconNode as palette } from 'lucide-react/dist/esm/icons/palette.js';
import { __iconNode as qrCode } from 'lucide-react/dist/esm/icons/qr-code.js';
import { __iconNode as share } from 'lucide-react/dist/esm/icons/share-2.js';
import { __iconNode as chevronLeft } from 'lucide-react/dist/esm/icons/chevron-left.js';
import { __iconNode as mail } from 'lucide-react/dist/esm/icons/mail.js';
import { __iconNode as type } from 'lucide-react/dist/esm/icons/type.js';
import { __iconNode as play } from 'lucide-react/dist/esm/icons/play.js';
import { __iconNode as desfazer } from 'lucide-react/dist/esm/icons/undo-2.js';
import { __iconNode as music } from 'lucide-react/dist/esm/icons/music.js';
import { __iconNode as triangleAlert } from 'lucide-react/dist/esm/icons/triangle-alert.js';
import { __iconNode as calendar } from 'lucide-react/dist/esm/icons/calendar.js';
import { __iconNode as clock } from 'lucide-react/dist/esm/icons/clock.js';
import { __iconNode as mapPin } from 'lucide-react/dist/esm/icons/map-pin.js';
import { __iconNode as video } from 'lucide-react/dist/esm/icons/video.js';
import { __iconNode as car } from 'lucide-react/dist/esm/icons/car.js';
import { __iconNode as key } from 'lucide-react/dist/esm/icons/key.js';
import { __iconNode as lock } from 'lucide-react/dist/esm/icons/lock.js';
import { __iconNode as settings } from 'lucide-react/dist/esm/icons/settings.js';
import { __iconNode as plus } from 'lucide-react/dist/esm/icons/plus.js';
import { __iconNode as minus } from 'lucide-react/dist/esm/icons/minus.js';
import { __iconNode as hospital } from 'lucide-react/dist/esm/icons/hospital.js';
import { __iconNode as userRound } from 'lucide-react/dist/esm/icons/user-round.js';
import { __iconNode as inbox } from 'lucide-react/dist/esm/icons/inbox.js';
import { __iconNode as clapperboard } from 'lucide-react/dist/esm/icons/clapperboard.js';
import { __iconNode as cake } from 'lucide-react/dist/esm/icons/cake.js';
import { __iconNode as scissors } from 'lucide-react/dist/esm/icons/scissors.js';
import { __iconNode as trophy } from 'lucide-react/dist/esm/icons/trophy.js';
import { __iconNode as medal } from 'lucide-react/dist/esm/icons/medal.js';
import { __iconNode as award } from 'lucide-react/dist/esm/icons/award.js';
import { __iconNode as thumbsUp } from 'lucide-react/dist/esm/icons/thumbs-up.js';
import { __iconNode as sun } from 'lucide-react/dist/esm/icons/sun.js';
import { __iconNode as hand } from 'lucide-react/dist/esm/icons/hand.js';
import { __iconNode as x } from 'lucide-react/dist/esm/icons/x.js';
import { __iconNode as cloudIcon } from 'lucide-react/dist/esm/icons/cloud.js';
import { __iconNode as database } from 'lucide-react/dist/esm/icons/database.js';
import { __iconNode as bell } from 'lucide-react/dist/esm/icons/bell.js';
import { __iconNode as megaphone } from 'lucide-react/dist/esm/icons/megaphone.js';
import { __iconNode as wallet } from 'lucide-react/dist/esm/icons/wallet.js';
import { __iconNode as atSign } from 'lucide-react/dist/esm/icons/at-sign.js';
import { __iconNode as building } from 'lucide-react/dist/esm/icons/building.js';
import { __iconNode as users } from 'lucide-react/dist/esm/icons/users.js';
import { __iconNode as repeat } from 'lucide-react/dist/esm/icons/repeat.js';
import { __iconNode as alignLeft } from 'lucide-react/dist/esm/icons/text-align-start.js';
import { __iconNode as copy } from 'lucide-react/dist/esm/icons/copy.js';
import { __iconNode as pencil } from 'lucide-react/dist/esm/icons/pencil.js';
// (2.5) Entraram com a troca dos emojis dos motivos do Tráfego por ícone monocromático.
import { __iconNode as trendingUp } from 'lucide-react/dist/esm/icons/trending-up.js';
import { __iconNode as trendingDown } from 'lucide-react/dist/esm/icons/trending-down.js';
import { __iconNode as target } from 'lucide-react/dist/esm/icons/target.js';
import { __iconNode as ban } from 'lucide-react/dist/esm/icons/ban.js';
import { __iconNode as layers } from 'lucide-react/dist/esm/icons/layers.js';
import { __iconNode as zap } from 'lucide-react/dist/esm/icons/zap.js';
import { __iconNode as moon } from 'lucide-react/dist/esm/icons/moon.js';
// (2.10) Entraram com a consolidação dos SVG desenhados à mão: são os desenhos que
// mais se repetiam inline e não tinham equivalente aqui. Contagem no relatório da fatia.
import { __iconNode as search } from 'lucide-react/dist/esm/icons/search.js';
import { __iconNode as eye } from 'lucide-react/dist/esm/icons/eye.js';
import { __iconNode as eyeOff } from 'lucide-react/dist/esm/icons/eye-off.js';
import { __iconNode as trash2 } from 'lucide-react/dist/esm/icons/trash-2.js';
import { __iconNode as chevronDown } from 'lucide-react/dist/esm/icons/chevron-down.js';
import { __iconNode as save } from 'lucide-react/dist/esm/icons/save.js';
import { __iconNode as checkCheck } from 'lucide-react/dist/esm/icons/check-check.js';
import { __iconNode as upload } from 'lucide-react/dist/esm/icons/upload.js';
import { __iconNode as download } from 'lucide-react/dist/esm/icons/download.js';
import { __iconNode as squareCheckBig } from 'lucide-react/dist/esm/icons/square-check-big.js';
// (2.10) A conferência no app logado mostrou o que o CSS não conta: os títulos dos
// painéis da Home ficaram com 13 e 14px LADO A LADO, porque metade dos desenhos era
// única e ficou de fora da primeira passada. Estes cinco fecham a fileira.
import { __iconNode as activity } from 'lucide-react/dist/esm/icons/activity.js';
import { __iconNode as chartColumn } from 'lucide-react/dist/esm/icons/chart-no-axes-column.js';
import { __iconNode as penTool } from 'lucide-react/dist/esm/icons/pen-tool.js';
import { __iconNode as send } from 'lucide-react/dist/esm/icons/send.js';
import { __iconNode as ellipsis } from 'lucide-react/dist/esm/icons/ellipsis.js';
import { __iconNode as fileText } from 'lucide-react/dist/esm/icons/file-text.js';
// A conferência achou também o MESMO desenho escrito de outra forma: a lupa em quatro
// notações, a lixeira em cinco, o lápis em três. Agrupar por texto do path não pega isso.
import { __iconNode as zoomIn } from 'lucide-react/dist/esm/icons/zoom-in.js';
import { __iconNode as zoomOut } from 'lucide-react/dist/esm/icons/zoom-out.js';
// (2.12) Entrou com a unificação dos logos de marca: o «Freela» da quebra de
// Produtividade era o último círculo-com-interrogação desenhado à mão do módulo.
// Vem de `circle-question-mark`, não do apelido `circle-help`: o apelido só
// reexporta o `default`, e o `__iconNode` sai `undefined` — a catraca do 2.10 pegou.
import { __iconNode as circleHelp } from 'lucide-react/dist/esm/icons/circle-question-mark.js';

import { lucideNodesToSvgString } from './lucideToSvg.js';

const LUCIDE_ICON_NODES = {
  check,
  warning: triangleAlert,
  calendar,
  clock,
  location: mapPin,
  users,
  repeat,
  description: alignLeft,
  copy,
  pencil,
  video,
  car,
  key,
  lock,
  settings,
  plus,
  minus,
  hospital,
  user: userRound,
  mailbox: inbox,
  film: clapperboard,
  birthday: cake,
  scissors,
  medal1: trophy,
  medal2: medal,
  medal3: award,
  thumbUp: thumbsUp,
  sun,
  music,
  handWave: hand,
  close: x,
  cloud: cloudIcon,
  database,
  bell,
  megaphone,
  wallet,
  mention: atSign,
  building,
  trendingUp,
  trendingDown,
  target,
  ban,
  layers,
  zap,
  moon,
  search,
  eye,
  eyeOff,
  trash: trash2,
  chevronDown,
  save,
  checkCheck,
  upload,
  download,
  checkSquare: squareCheckBig,
  activity,
  chartColumn,
  penTool,
  send,
  more: ellipsis,
  fileText,
  zoomIn,
  zoomOut,
  circleHelp,
  arrowUp,
  arrowDown,
  externalLink,
  link,
  gripVertical,
  image,
  palette,
  qrCode,
  share,
  chevronLeft,
  mail,
  type,
  play,
  desfazer,
};

const DEFAULT_SIZE = 16;

/**
 * (2.10) A MEDIDA DO ÍCONE — uma escala, não dezenove tamanhos.
 *
 * Os 162 SVG desenhados à mão saíam em 20 tamanhos (9 a 24px) e 15 espessuras de
 * traço (1,5 a 3,5). Contando os usos: viewBox 24 em 154 dos 162, traço 2 em 85 e
 * tamanho 14 em 36 — o mais usado. O 14 também é o TETO que preserva o botão do
 * 2.9: `.btn` tem min-height 34, recheio 8 e borda 1,5 em border-box, o que deixa
 * 15px de altura de conteúdo. Ícone de 16 empurraria o botão para 35.
 *
 * BOTAO (14) — ícone ao lado de texto em botão, campo ou título de painel. O texto
 *               que ele acompanha é letra 12 nos três casos (`.btn`, `.home-panel-title`).
 * DENSO (12) — chip apertado, caret, tique de caixa de seleção.
 * GRANDE (16) — glifo SOZINHO, sem texto ao lado: botão quadrado de 34px
 *               (`.tp-icon-btn`) e ícone de título de seção. É o padrão histórico
 *               do registro, então não muda nada de quem já o consumia.
 */
export const ICO = { DENSO: 12, BOTAO: 14, GRANDE: 16 };

/** Traço: 2 é a maioria e o nativo do Lucide. O tique da caixa de seleção pede
 *  mais corpo para ler a 12px — colapsa os 3,2 e 3,5 que existiam em um 3. */
export const ICO_TRACO = { PADRAO: 2, TIQUE: 3 };

/** Geometria crua (formato `__iconNode` do Lucide) para quem renderiza em JSX. */
export const UI_ICON_NODES = LUCIDE_ICON_NODES;

/** Mapa nome → SVG string (16×16 por padrão), para innerHTML direto */
export const UI_ICONS = Object.fromEntries(
  Object.entries(LUCIDE_ICON_NODES).map(([k, nodes]) => [
    k,
    lucideNodesToSvgString(nodes, { width: DEFAULT_SIZE, height: DEFAULT_SIZE }),
  ]),
);

/**
 * @param {string} iconKey
 * @param {number} [size] - largura/altura em px (padrão 16)
 * @param {string} [className] - classe NO PRÓPRIO `<svg>`. Necessário quando o CSS
 *   posiciona o ícone (ex.: `.notif-filter-chevron` é absoluto no svg): sem isso o
 *   desenho aparece, mas fora do lugar.
 */
export function getUiIconHtml(iconKey, size = DEFAULT_SIZE, className) {
  const nodes = LUCIDE_ICON_NODES[iconKey];
  return nodes ? lucideNodesToSvgString(nodes, { width: size, height: size, className }) : '';
}

/** Wrapper com span para listas e textos */
export function iconInline(iconKey, size = DEFAULT_SIZE) {
  const html = getUiIconHtml(iconKey, size);
  return html ? `<span class="ui-icon-inline">${html}</span>` : '';
}
